'use client';

const getRestProps = ({
  label: _label,
  a11yLabel: _a11yLabel,
  caption: _caption,
  iconStyle: _iconStyle,
  iconPosition: _iconPosition,
  dataQa: _dataQa,
  active: _active,
  variant: _variant,
  status: _status,
  disabled: _disabled,
  role: _role,
  ...rest
}) => rest;
export {
  getRestProps
};
